import styles from './Separator.css'

class Separator extends React.Component {
  render () {
    return <div className={styles.wrapper} />
  }
}

export default Separator



// WEBPACK FOOTER //
// ./app/pages/Inventory/PurchaseOrder/PurchaseOrderDetail/Separator/Separator.js